import script from "./Webcam.vue?vue&type=script&setup=true&lang=js"
export * from "./Webcam.vue?vue&type=script&setup=true&lang=js"

import "./Webcam.vue?vue&type=style&index=0&id=d98bedec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d98bedec"]])

export default __exports__